import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-advice',
    templateUrl: './advice.component.html',
    styleUrls: ['./advice.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AdviceComponent implements OnInit {

  type: string = 'error';
  timeOut: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<AdviceComponent>) { }

  ngOnInit(): void {
    this.type = this.data['type'];
    this.autoClose();
  }

  close() {
    this.dialogRef.close();
  }

  autoClose() {
    this.timeOut = setTimeout(()=>{
      this.close();
    }, 5000);
  }

}
